export default {
  title: 'Carousel Container'
}

const styles = {
  carouselItem: 'display:flex;',
  carouselItemContent: 'display:grid;place-items:center;width:100%;height:100%;'
}

const Template = args => `
  <cradlepoint-carousel-container
    height="${args.height ? args.height : '600px'}"
    max-width="${args.maxWidth ? args.maxWidth : '1280px'}"
    show-arrows="${args.showArrows}"
    show-dots="${args.showDots}"
    inside-arrows="${args.insideArrows}"
    inside-dots="${args.insideDots}"
  >
    ${args.content}
  </cradlepoint-carousel-container>
`;

export const Default = Template.bind({});

Default.args = {
  height: '600px',
  maxWidth: '1280px',
  showArrows: true,
  showDots: true,
  insideArrows: false,
  insideDots: false,
  content: `
    <div class="carousel-item" style="${styles.carouselItem}">
      <div style="${styles.carouselItemContent} background-color:var(--cwc-color-primary, #FFAD00);">full</div>
    </div>
    <div class="carousel-item" style="display:flex;">
      <div style="${styles.carouselItemContent} background-color:var(--cwc-color-accent-b, #008EAA);">left</div>
      <div style="${styles.carouselItemContent} background-color:var(--cwc-color-accent-c, #0057B8);">right</div>
    </div>
    <div class="carousel-item" style="display:flex;flex-direction:column;">
      <div style="${styles.carouselItemContent} background-color:var(--cwc-color-accent-d, #C1C6C8);">top</div>
      <div style="${styles.carouselItemContent} background-color:var(--cwc-color-accent-a, #009A44);">bottom</div>
    </div>
  `
}
